import React from 'react';
import PropTypes from 'prop-types';

import isFunction from 'lodash/isFunction';

export default class RightHandLinkButton extends React.PureComponent {

  constructor(props) {
    super(props);

    this.openLink = this.openLink.bind(this);
  }

  openLink() {
    const { onClick } = this.props;
    if (isFunction(onClick)) {
      onClick();
    } else {
      this.props.openElementLink(this.props.dataLinkType);
    }
  }

  render() {
    const { type, size, iconPosition, text, icon, children } = this.props;

    return (
      <button
        tabIndex='0'
        onClick={this.openLink}
        className={`els-btn els-btn-${size} els-btn-${type} els-btn-${iconPosition} e2e-righthand-${type}`}>
        {iconPosition === 'left' ? (
          <svg className='els-btn-icon'>
            <use xlinkHref={`#icon-${icon}`}/>
          </svg>
        ) : null}

        {text ? <span>{text}</span> : null}

        {iconPosition === 'right' ? (
          <svg className='els-btn-icon'>
            <use xlinkHref={`#icon-${icon}`}/>
          </svg>
        ) : null}
        {children}
      </button>
    );
  }
}

RightHandLinkButton.propTypes = {
  onClick: PropTypes.func,
  type: PropTypes.string.isRequired,
  size: PropTypes.string.isRequired,
  iconPosition: PropTypes.string.isRequired,
  dataLinkType: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
  icon: PropTypes.string.isRequired,
  openElementLink: PropTypes.func.isRequired,
};
